import React from 'react';
import { useTranslation } from 'react-i18next';
import OpArticle, { ArticleSection } from '../components/optimus/OpArticle';

interface FirebaseCloudSetupPageProps {
  darkMode: boolean;
}

const CODE_RULES = `// firestore.rules
rules_version = '2';
service cloud.firestore {
  match /databases/{database}/documents {
    match /users/{userId}/{document=**} {
      allow read, write: if request.auth != null
                         && request.auth.uid == userId;
    }
  }
}`;

const FirebaseCloudSetupPage: React.FC<FirebaseCloudSetupPageProps> = ({ darkMode }) => {
  const { t } = useTranslation();
  const b = 'op.blog.fire';

  const sections: ArticleSection[] = [
    { title: t(`${b}.s1t`), paragraphs: [t(`${b}.s1p1`)] },
    { title: t(`${b}.s2t`), paragraphs: [t(`${b}.s2p1`)] },
    { title: t(`${b}.s3t`), paragraphs: [t(`${b}.s3p1`)] },
    {
      title: t(`${b}.s4t`),
      paragraphs: [t(`${b}.s4p1`)],
      code: { filename: 'firestore.rules', content: CODE_RULES },
    },
    { title: t(`${b}.s5t`), paragraphs: [t(`${b}.s5p1`)] },
  ];

  const takeaways = [1, 2, 3, 4].map((n) => ({
    title: t(`${b}.k${n}t`),
    description: t(`${b}.k${n}d`),
  }));

  return (
    <OpArticle
      darkMode={darkMode}
      slug="firebase-cloud-setup"
      category={t(`${b}.category`)}
      title={t('blogPosts.firebaseCloudSetup.title')}
      description={t('blogPosts.firebaseCloudSetup.description')}
      date="2024-12-26"
      readingTime={6}
      tags={['Firebase', 'Firestore', 'Authentication', 'Cloud Functions', 'Security Rules']}
      seoKeywords="firebase cloud setup, firestore configuration, firebase authentication, security rules, cloud functions"
      sections={sections}
      takeaways={takeaways}
    />
  );
};

export default FirebaseCloudSetupPage;
